const appendNavigationData = (item, container) => {
    const template = `
        <li>
            <a href="/${item.slug}" class="nav__item">${item.title.rendered}</a>
        </li>
    `;
    container?.insertAdjacentHTML('beforeend', template);
}

export {
    appendNavigationData
}